import styled, { css } from 'styled-components';

import { resetButton } from 'styles/common';

export const Container = styled.div`
  position: fixed;
  top: 20px;
  left: 20px;
  z-index: 10;

  @media (max-width: 600px) {
    top: 76px;
    left: 10px;
  }
`;

export const Button = styled.button`
  ${resetButton}
  padding: 6px 18px;
  border-radius: 0px;
  background: radial-gradient(circle at 35% 30%, rgba(0, 204, 255, 0.2), rgba(0, 17, 34, 0.9));
  border: 1px solid rgba(0, 204, 255, 0.7);
  box-shadow:
    0 0 14px rgba(0, 204, 255, 0.25),
    inset 0 0 10px rgba(0, 204, 255, 0.08);
  color: rgba(200, 230, 255, 0.9);
  font-family: 'Rajdhani', sans-serif;
  font-size: 16px;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.3s ease;
  text-transform: uppercase;
  display: flex;
  align-items: center;
  justify-content: center;

  &:hover {
    border-color: rgba(0, 204, 255, 1);
    box-shadow:
      0 0 22px rgba(0, 204, 255, 0.4),
      inset 0 0 14px rgba(0, 204, 255, 0.15);
  }

  &:active {
    transform: scale(0.93);
  }

  @media (max-width: 600px) {
    padding: 4px 14px;
    font-size: 13px;
  }
`;

export const Dropdown = styled.div<{ $isOpen: boolean }>`
  display: none;
  position: absolute;
  top: calc(100% + 10px);
  left: 0;
  min-width: 150px;
  background: rgba(10, 10, 20, 0.75);
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 10px;
  backdrop-filter: blur(20px);
  overflow: hidden;
  z-index: 200;
  box-shadow: 0 8px 40px rgba(0, 0, 0, 0.4);
  overflow-y: auto;

  ${({ $isOpen }) =>
    $isOpen &&
    css`
      display: block;
    `}
`;

export const Option = styled.button<{ $isActive: boolean }>`
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 9px 14px;
  color: rgba(255, 255, 255, 0.5);
  font-family: 'Share Tech Mono', monospace;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  border: none;
  background: none;
  width: 100%;
  text-align: left;
  white-space: nowrap;

  &:hover {
    background: rgba(255, 255, 255, 0.06);
    color: rgba(255, 255, 255, 0.85);
  }

  ${({ $isActive }) =>
    $isActive &&
    css`
      color: rgba(255, 255, 255, 0.9);
    `}

  @media (max-width: 600px) {
    padding: 5px 10px;
    font-size: 12px;
  }
`;

export const OptionIcon = styled.span`
  font-size: 16px;
  width: 18px;
  text-align: center;
`;
